import { gql } from '@gql-generated/gql'

gql(/* GraphQL */ `
  query GetReassuranceCards($tenantId: JSON) {
    CMS_ReassuranceCards(
      where: { tenant: { equals: $tenantId }, AND: [{ _status: { equals: published } }] }
    ) {
      docs {
        layout {
          ... on CMS_ReassuranceCardBlock {
            ...Footer_ReassuranceCards
          }
        }
      }
    }
  }
`)

type Link = {
  title: string
  links: {
    [key: string]: {
      name: string
      href: string
    }
  }
}

export function sortFooterLinks(a: [string, Link], b: [string, Link]) {
  const order = ['aboutUs', 'products', 'needHelp']

  return order.indexOf(a[0]) - order.indexOf(b[0])
}
